import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgZone } from '@angular/core';
import { ErrorService } from 'src/app/error.service';
import { ColumnChangeBO } from '../../list/list.model';
import { saveupdateAuthorizationBo } from '../client-parent.model';
@Injectable({
    providedIn: 'root'
})
export class ClientAuthService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };
    constructor(private http: HttpClient, public errorService: ErrorService, public toastrService: ToastrService, public zone: NgZone) { }
    
    GetGroupPayorList(): Observable<any> {
        let url = "api/Payer/GetGroupPayorList";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    GetServiceDropdown(): Observable<any> {
        let url = "api/Service/GetServiceDropdown";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    
    getLovTypes(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Lov/GetLovDropDown?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    SaveClientAuth(save: saveupdateAuthorizationBo): Observable<any> {
        let url = "api/ClientAuthorization/SaveClientAuth";
        return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    updateClientAuth(save: saveupdateAuthorizationBo): Observable<any> {
        let url = "api/ClientAuthorization/UpdateClientAuth";
        return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    savecolumwidth(list: ColumnChangeBO): Observable<any> {

        let url = "api/ColumnChange/Savewidth?";
        return this.http.post<any>(url, list, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    GetServiceDropdownBasedonAuthType(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Service/GetServiceDropdownBasedonAuthType?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    
    getCompanyDropDown(): Observable<any> {
        let url = "api/Budget/getCompany?";
        return this.http.get<any>(url , { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
}